(() => {
  const loader = document.getElementById('AlesBrandLoader');
  const state = window.__alesBrandLoader;

  if (!loader || !state || loader.hidden) return;

  const number = loader.querySelector('[data-ales-loader-number]');
  const progressbar = loader.querySelector('[data-ales-loader-progress]');
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const startedAt = state.startedAt;
  const minimumDuration = prefersReducedMotion
    ? 220
    : Math.max(800, Math.min(Number(loader.dataset.minDuration) || 1200, 2000));
  const maximumDuration = prefersReducedMotion
    ? 1000
    : Math.max(minimumDuration + 700, Number(loader.dataset.maxDuration) || 4000);
  const approachDuration = prefersReducedMotion ? 80 : 800;
  const finalDuration = prefersReducedMotion ? 0 : 200;
  const holdDuration = prefersReducedMotion ? 40 : 220;
  const exitDuration = prefersReducedMotion ? 180 : 540;
  const forceFinalAt = startedAt + maximumDuration - finalDuration - holdDuration - exitDuration;

  let currentProgress = 0;
  let finishing = false;
  let pageLoaded = document.readyState === 'complete';
  let animationFrameId = 0;
  let removed = false;

  const setProgress = (value) => {
    const next = Math.max(currentProgress, Math.min(value, 100));
    currentProgress = next;
    const rounded = Math.round(next);

    loader.style.setProperty('--ales-loader-progress', next.toFixed(2));

    if (number) number.textContent = String(rounded).padStart(2, '0');
    if (progressbar) progressbar.setAttribute('aria-valuenow', String(rounded));
  };

  const removeLoader = () => {
    if (removed) return;
    removed = true;
    window.cancelAnimationFrame(animationFrameId);
    window.clearTimeout(state.failsafeId);
    document.documentElement.classList.remove('ales-loader-active');
    loader.hidden = true;
    loader.setAttribute('aria-hidden', 'true');
    loader.remove();
    window.dispatchEvent(new CustomEvent('ales:loader:hidden'));
  };

  const exit = () => {
    loader.dataset.state = 'exiting';
    loader.addEventListener('transitionend', removeLoader, { once: true });
    window.setTimeout(removeLoader, exitDuration + 80);
  };

  const finish = () => {
    if (finishing) return;
    finishing = true;

    const finalStartedAt = performance.now();
    const initialProgress = currentProgress;

    const completeProgress = (now) => {
      if (finalDuration === 0) {
        setProgress(100);
      } else {
        const ratio = Math.min((now - finalStartedAt) / finalDuration, 1);
        const eased = 1 - Math.pow(1 - ratio, 3);
        setProgress(initialProgress + (100 - initialProgress) * eased);

        if (ratio < 1) {
          animationFrameId = window.requestAnimationFrame(completeProgress);
          return;
        }
      }

      const holdUntil = Math.max(startedAt + minimumDuration, performance.now() + holdDuration);
      window.setTimeout(exit, Math.max(0, holdUntil - performance.now()));
    };

    animationFrameId = window.requestAnimationFrame(completeProgress);
  };

  const tick = (now) => {
    if (finishing) return;

    const elapsed = now - startedAt;
    const approachRatio = Math.min(elapsed / approachDuration, 1);
    const easedApproach = 1 - Math.pow(1 - approachRatio, 3);
    let nextProgress = 92 * easedApproach;

    if (elapsed > approachDuration) {
      nextProgress = Math.min(96, 92 + ((elapsed - approachDuration) / 900) * 4);
    }

    setProgress(nextProgress);

    if ((pageLoaded && elapsed >= approachDuration) || now >= forceFinalAt) {
      finish();
      return;
    }

    animationFrameId = window.requestAnimationFrame(tick);
  };

  const markLoaded = () => {
    pageLoaded = true;
  };

  window.addEventListener('load', markLoaded, { once: true });
  window.addEventListener('pagehide', removeLoader, { once: true });
  window.addEventListener(
    'pageshow',
    (event) => {
      if (event.persisted) removeLoader();
    },
  );

  setProgress(0);
  animationFrameId = window.requestAnimationFrame(tick);
})();
